/* eslint-disable react/prop-types */
import React from 'react';
import PrintIcon from '../../../../../../../../../assets/icons/print-icon.svg';

export const PrintAssessmentSummary = ({handlePrint}) => (
  <button type="button" className="action-btn" onClick={handlePrint}>
    <img src={PrintIcon} alt="logo" />
  </button>
);
